module.exports = __webpack_public_path__ + "assets-cabinet/img/clock-icon.cc545b9a.svg";